'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var react = require('@chakra-ui/react');
var useAccordion = require('./useAccordion.js');
var utils = require('@chakra-ui/utils');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var _excluded = ["children", "reduceMotion"],
  _excluded2 = ["htmlProps", "descendants"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty__default["default"](target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
/**
 * Accordion
 *
 * The wrapper that provides context and focus management
 * for all accordion items.
 *
 * It wraps all accordion items in a `div` for better grouping.
 * @see Docs https://chakra-ui.com/accordion
 */
var Accordion = react.forwardRef(function (_ref, ref) {
  var children = _ref.children,
    reduceMotion = _ref.reduceMotion,
    props = _objectWithoutProperties__default["default"](_ref, _excluded);
  var styles = react.useMultiStyleConfig('Accordion', props);
  var ownProps = react.omitThemingProps(props);
  var _useAccordion = useAccordion.useAccordion(ownProps),
    htmlProps = _useAccordion.htmlProps,
    descendants = _useAccordion.descendants,
    context = _objectWithoutProperties__default["default"](_useAccordion, _excluded2);
  var ctx = React__default["default"].useMemo(function () {
    return _objectSpread(_objectSpread({}, context), {}, {
      reduceMotion: !!reduceMotion
    });
  }, [context, reduceMotion]);
  return /*#__PURE__*/React__default["default"].createElement(useAccordion.AccordionDescendantsProvider, {
    value: descendants
  }, /*#__PURE__*/React__default["default"].createElement(useAccordion.AccordionProvider, {
    value: ctx
  }, /*#__PURE__*/React__default["default"].createElement(react.StylesProvider, {
    value: styles
  }, /*#__PURE__*/React__default["default"].createElement(react.chakra.div, _extends__default["default"]({
    ref: ref
  }, htmlProps, {
    __css: styles.container,
    className: utils.cx('chakra-accordion', props.className)
  }), children))));
});
Accordion.displayName = 'Accordion';
exports.Accordion = Accordion;